module.exports = __webpack_public_path__ + "media/hero.0e31d607.mp4";